import React, { useEffect, useState } from 'react';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { Collapse } from '@material-ui/core';
import { instanceAxios } from '../../../InstanceAxios';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '60%',
    height: '60%',
    overflow: 'auto',
  },
  button: {
    marginTop: theme.spacing(2),
  },
  loading: {
    marginLeft: '50%',
  },
}));

function ReembolsoModal({
  openModal,
  setOpenModal,
  idPagamento,
  setAlert,
  setAlertType,
  setMessage,
}) {
  const classes = useStyles();
  const [motivo, setMotivo] = useState('');
  const [errorMotivo, setErrorMotivo] = useState(false);
  const [ready, setReady] = useState(true);

  useEffect(() => {
    setMotivo('');
  }, [idPagamento]);

  const handleReembolso = async () => {
    if (!motivo) {
      setErrorMotivo(true);
      return;
    }
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post('/reembolso', {
        id: idPagamento,
        motivo,
      })
      .then((data) => {
        setMessage('Pagamento Reembolsado com sucesso!');
        setAlertType('success');
        setAlert(true);
        setReady(true);
        setOpenModal(false);
      })
      .catch((err) => {
        const error = err.response.data.message.errors
          ? err.response.data.message.errors
          : 'Erro ao realizar reembolso, tente novamente mais tarde!';
        setMessage(error);
        setAlertType('error');
        setAlert(true);
        setReady(true);
        setOpenModal(false);
      });
  };

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={openModal}
      onClose={() => {
        setOpenModal(false);
      }}
    >
      <div className={classes.paper}>
        <Grid container direction="row" justify="center" alignItems="center">
          <h1>Motivo Reembolso</h1>
        </Grid>
        <Collapse in={ready}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <TextField
                error={errorMotivo}
                multiline
                fullWidth
                variant="outlined"
                rows={8}
                value={motivo}
                onChange={(event) => {
                  setErrorMotivo(false);
                  setMotivo(event.target.value);
                }}
                helperText="Digite o motivo do reembolso! Esse Campo é obrigatório!"
              />
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  startIcon={<SaveIcon />}
                  onClick={handleReembolso}
                >
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
        <Collapse in={!ready}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </div>
    </Modal>
  );
}

export default ReembolsoModal;
